<template>
  <!-- 订单查询 -->
  <div class="orderInquiry dialogSetting">
    <div class="orderInquiry__left scrollbar marginRight10">
      <div style="height: 100%; display: flex; flex-direction: column">
        <div class="bcWhite box-shadow padding10 marginBottom10">
          <el-select v-model="queryParams.status" placeholder="订单状态" class="marginRight10" clearable>
            <el-option label="新订单" value="1" />
            <el-option label="异常订单" value="2" />
            <el-option label="催单" value="3" />
            <el-option label="配送异常" value="4" />
            <el-option label="取消/退款" value="5" />
            <el-option label="预订单" value="6" />
            <el-option label="待抢单" value="7" />
            <el-option label="待取货" value="8" />
            <el-option label="配送中" value="9" />
            <el-option label="待处理" value="10" />
            <el-option label="已完成" value="0" />
            <el-option label="加单完成" value="12" />
            <el-option label="已取消" value="13" />
          </el-select>
          <el-select v-model="queryParams.deliveryType" placeholder="订单标签" class="marginRight10" clearable>
            <el-option label="同城配送" value="1" />
            <el-option label="顾客自提" value="2" />
            <el-option label="平台配送" value="3" />
            <el-option label="平台切自配" value="4" />
          </el-select>
          <el-select v-model="queryParams.platType" placeholder="订单来源" class="marginRight10" clearable>
            <el-option label="美团" value="1" />
            <el-option label="饿了么" value="2" />
            <el-option label="京东" value="3" />
            <el-option label="小程序商城" value="4" />
            <el-option label="TOPS订单" value="6" />
          </el-select>
          <el-select v-model="queryParams.cshop" filterable placeholder="请选择店铺" clearable class="marginRight10">
            <el-option v-for="item in shopOptions" :key="item.sid" :label="item.cname" :value="item.sid"></el-option>
          </el-select>
          <el-select v-model="queryParams.rstore" filterable placeholder="请选择门店" clearable class="marginRight10">
            <el-option v-for="item in storeList" :key="item.sid" :label="item.cname" :value="item.sid"></el-option>
          </el-select>
          <el-select ref="sortSelect" v-model="sortingValue" class="marginRight10" placeholder="排序方式">
            <el-option label="下单时间倒序" value="s_order_time-0"></el-option>
            <el-option label="下单时间正序" value="s_order_time-1"></el-option>
            <el-option label="抢单时间倒序" value="s_receive_time-0"></el-option>
            <el-option label="抢单时间正序" value="s_receive_time-1"></el-option>
            <el-option label="预计送达倒序" value="s_wish_time-0"></el-option>
            <el-option label="预计送达正序" value="s_wish_time-1"></el-option>
          </el-select>
          <el-date-picker v-model="orderDate" value-format="yyyy-MM-dd" class="marginTop10" align="right" type="daterange" unlink-panels start-placeholder="开始日期" end-placeholder="结束日期" />
          &nbsp;<el-input v-model="address" clearable placeholder="顾客地址" style="width: 200px;"/>
          <el-input v-model="search" clearable placeholder="手机、订单号、TOPS号" class="marginLeft10 w300 input-with-select" @keyup.enter.native="changeListData">
            <el-button slot="append" icon="el-icon-search" @click="changeListData"></el-button>
          </el-input>
          <br><br>
          <el-button type="primary" @click="reset">重置</el-button>&nbsp;&nbsp;
          快速查询
          <el-switch v-model="fast" :active-value="1" :inactive-value="2" class="marginLeft20" />
        </div>
        <div class="bcWhite scrollbar box-shadow" style="height: 100%" v-loading="loading">
          <orderListForInquiry ref="orderList" class="hHP" @changeListInfoData="changeListInfoData" @handleEndSearch="handleEndSearch"/>
        </div>
      </div>
    </div>
    <div class="orderInquiry__right flex">
      <div class="bcWhite box-shadow" style="flex: 1">
        <OrderListInfo ref="orderListInfo" class="bcWhite box-shadow" @changeListData="changeListData" />
      </div>
    </div>
  </div>
</template>

<script>
import orderListForInquiry from "@/views/order/orderListForInquiry.vue";
import OrderListInfo from "@/views/order/orderListInfo.vue";
import moment from "moment";
import { EventBus } from "@/store/event-bus";
export default {
  name: "OrderInquiry",
  components: {
    orderListForInquiry,
    OrderListInfo
  },
  props: {},
  data() {
    return {
      orderId: this.$route.query.orderId,
      orderDate: [],
      //门店筛选
      shopOptions: [],
      storeList: [],
      sortingValue: "s_order_time-0",
      //订单列表数据
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        search: "",
        status: "",
        deliveryType: "",
        platType: "",
        cshop: "",
      },
      fast: 1,
      search: "",
      address: "",
      loading: false,
    };
  },
  mounted() {
    if (this.orderId !== undefined) {
      this.search = this.orderId;
    }
    this.changeListData();
    this.queryShop();
    this.queryStore();
    EventBus.$on("refreshPage", this.handleCalling);
  },
  beforeDestroy() {
    EventBus.$off("refreshPage");
  },
  methods: {
    handleCalling(data) {
      if (data === undefined) {
        return;
      }
      let json = JSON.parse(data);
      if (json.type === "callRing") {
        this.$confirm("您有新来电，是否应答并获取订单？")
          .then((_) => {
            this.topsAjax.get(`${this.baseUrls.websocket}/answer`, { userId: json.userId });
            this.$router.push({ path: "/order/orderInquiry", query: { orderId: json.orderId } });
          })
          .catch((_) => {});
      }
    },
    changeListData() {
      this.loading = true;
      this.queryParams.fast = this.fast;
      if (this.orderDate && this.orderDate.length === 2) {
        this.queryParams.startDate = this.orderDate[0];
        this.queryParams.endDate = this.orderDate[1];
      }
      this.queryParams.search = this.search;
      this.queryParams.address = this.address;
      this.queryParams.field = this.sortingValue.split("-")[0];
      this.queryParams.isAsc = this.sortingValue.split("-")[1];
      this.$refs.orderList.changeListData(this.queryParams);
    },
    handleEndSearch() {
      this.loading = false;
    },
    changeListInfoData(sid) {
      this.$refs.orderListInfo.changeListInfoData(sid);
    },
    refreshPage() {
      this.changeListData();
      this.queryShop();
    },
    /**
     * 重置
     */
    reset() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        search: "",
        status: "",
        deliveryType: "",
        platType: "",
        cshop: "",
      };
      this.orderDate = [];
      this.sortingValue = "s_order_time-0";
      this.search = "";
      this.changeListData();
    },
    // 查询所有商铺列表
    queryShop() {
      this.topsAjax.get(`${this.baseUrls.orderShop}/queryList`, {
        bDelete: 0,
        bValid: 1,
      }).then((res) => {
        this.shopOptions = res;
      });
    },
    queryStore() {
      let url = `${this.baseUrls.orderStore}/queryList`;
      this.topsAjax.get(url, { bStatus: 2 }).then((response) => {
        this.storeList = response;
      });
    }
  },
};
</script>
<style lang="scss">
.export {
  .el-checkbox__label {
    width: 80px;
  }
}
.orderInquiry {
  overflow: hidden;
  display: flex;
  flex-direction: row;
  flex: 1;
  height: 100%;

  &__left {
    padding: 3px;
    flex: 1;
    overflow: auto;
  }

  &__right {
    padding: 3px;
    width: 30%;
  }

  .el-form-item {
    margin-bottom: 0;
  }
}
.dialogSetting {
  .el-dialog {
    margin: 0 auto 0;
    height: 100%;
  }
  .el-dialog--center .el-dialog__body {
    padding: 0 0 10px 30px;
  }
}
</style>
